export const getPatientName = (chat) => {
  if (chat.anonymous) {
    return "Anonymous Patient";
  }

  if (chat?.appointment_info && !chat.appointment_info?.is_me) {
    return `${chat.appointment_info.visitor.first_name} ${chat.appointment_info.visitor.last_name}`;
  }

  return chat.payment.payer.fullname;
};

export const getPatientInitials = (chat) => {
  var fullname = chat.payment.payer.fullname;

  return chat.anonymous ? fullname : (fullname.match(/\b\w/g) === null ? fullname.slice(0, 2) : fullname.match(/\b\w/g).slice(0, 2).join('.').toUpperCase())
}

export const getBodyParts = (parts) => {
  let bodyParts = [];
  if(parts){
    Object.keys(parts).forEach(key => {
      bodyParts.push(`${key} - ${parts[key].join(', ')}`);
    })
  }
  return bodyParts;
}